import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { getTranslatedString } from 'helpers/i18n';
import Unit from './fields/Unit';
import Resident from './fields/Resident';
import DescriptionInput from './fields/Description';
import PaymentAmountInput from './fields/Amount';
import PaymentMethod from './fields/PaymentMethod';
import { VerticalFormWrapper } from 'components/ui/VerticalFormWrapper';

import { getUnits, getResidentsOfUnitWithPAPDetails } from 'actions/landlordPropertiesActions';

const BatchPaymentForm = ({
  formName,
  formData,
  handleSubmit,
  batch,
  units,
  getUnits,
  getResidents,
  disabled,
}) => {
  // for the edit form, fetch the list of residents for the current unit
  const unitId = formData.unit_id;
  useEffect(() => {
    if (unitId) {
      getResidents(unitId);
    }
  }, [unitId, getResidents]);

  const validateForm = async (values) => {
    const requiredErrorVerbiage = getTranslatedString('required');
    let validationSchema = {
      unit_id: Yup.string().required(requiredErrorVerbiage),
      cotenant_id: Yup.string().required(requiredErrorVerbiage),
      amount: Yup.string().required(requiredErrorVerbiage),
      description: Yup.string().required(requiredErrorVerbiage),
      payment_method: Yup.string().required(requiredErrorVerbiage),
    };
    const schema = Yup.object().shape(validationSchema);
    return schema.validate(values, { abortEarly: false }).catch((error) => {
      throw yupToFormErrors(error);
    });
  };

  const initialValues = {
    batch_id: batch.id,
    unit_id: formData.unit_id || undefined,
    cotenant_id: formData.cotenant_id || undefined,
    amount: formData.amount || undefined,
    description: formData.description || undefined,
    payment_method: formData.payment_method || undefined,
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validateForm}>
      {({ handleSubmit, ...rest }) => (
        <VerticalFormWrapper id={formName} onSubmit={handleSubmit}>
          <Unit
            units={units}
            getUnits={getUnits}
            getResidents={getResidents}
            selectedBatch={batch}
            disabled={disabled}
            {...rest}
          />
          <Resident disabled={disabled} {...rest} />
          <PaymentAmountInput disabled={disabled} {...rest} />
          <DescriptionInput disabled={disabled} {...rest} />
          <PaymentMethod disabled={disabled} {...rest} />
        </VerticalFormWrapper>
      )}
    </Formik>
  );
};

const mapStoreToProps = (store) => ({
  batch: store.landlord.batches.selectedBatch,
  units: store.landlordProperties.units,
});

const mapDispatchToProps = {
  getUnits,
  getResidents: getResidentsOfUnitWithPAPDetails,
};

export default connect(mapStoreToProps, mapDispatchToProps)(BatchPaymentForm);
